const wrapper = "_35sw1bne9p5";
const dragOverlayContent = "_35sd7rns4h";

export { dragOverlayContent, wrapper };
import "./container.input.style.linaria.module.css";
//# sourceMappingURL=container.input.style.js.map
